import React from "react";
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';


const CustomCheckboxTree = props => {
    return (
        <div>
            {console.log("@@123alreadychec",props.selectChildValueCheckbox)}
            {console.log("@@123alreadyexp",props.selectChildValueCheckboxExpanded)}
            <CheckboxTree
                //noCascade
              //showPartiallySelected="true"
              checkModel="all"
              nodes={props.nodes}
              checked={props.selectChildValueCheckbox}
              expanded={props.selectChildValueCheckboxExpanded}
              onCheck={props.checked}
              onExpand={props.expanded}
            /> 
        </div>    
    );
}

export default CustomCheckboxTree;
